import * as React from 'react';
import {FC} from 'react';
import {storage} from "utils";
import {RootRoutes} from "enums";
import {useNavigate} from "react-router-dom";

interface Props {
    userId?: string;
    isSuperAdmin?: boolean;
    onIdle: () => void;
}

export const IdleMonitor: FC<Props> = ({userId, isSuperAdmin, onIdle}) => {
    let idleRef = React.useRef(0).current;
    let logoutTimerRef = React.useRef<NodeJS.Timeout | null>(null); // Track background logout timer

    const navigate = useNavigate();
    const minIdle = isSuperAdmin ? 10 : 3;

    React.useEffect(() => {
        if (!userId) return;

        let idleInterval = setInterval(timerIncrement, 1000); // 1 sec interval

        function timerIncrement() {
            idleRef += 1;

            if (idleRef > (60 * minIdle)) {
                logoutUser();
            }
        }

        function resetIdleRef() {
            idleRef = 0;
        }

        function handleVisibilityChange() {
            if (document.hidden) {
                // Start a timer when the tab is hidden
                logoutTimerRef.current = setTimeout(logoutUser, minIdle * 60 * 1000); // 2 minutes
            } else {
                // Clear the timer if the user returns
                if (logoutTimerRef.current) {
                    clearTimeout(logoutTimerRef.current);
                    logoutTimerRef.current = null;
                }
            }
        }

        function logoutUser() {
            onIdle();
            clearInterval(idleInterval);
            storage.clearAll();
            navigate(RootRoutes.Login);
            window.location.reload();
        }

        document.body.addEventListener('mousemove', resetIdleRef);
        document.body.addEventListener('keypress', resetIdleRef);
        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.body.removeEventListener('mousemove', resetIdleRef);
            document.body.removeEventListener('keypress', resetIdleRef);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            clearInterval(idleInterval);
            if (logoutTimerRef.current) {
                clearTimeout(logoutTimerRef.current);
            }
        };
    }, [onIdle, isSuperAdmin, userId, navigate]);

    return null;
};
